module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperFilterModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CSM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ShopperFilter', {
    ref: "shopperFilterComponent",
    attrs: {
      "currentFilterObject": _vm.filterObject,
      "locationPropertiesList": _vm.locationPropertiesList,
      "countryList": _vm.countryList
    },
    on: {
      "filterUpdate": function($event) {
        _vm.filterObject = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyFilter()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button",
      "disabled": !_vm.copyData.filterObject || _vm.copyData.client !== _vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.restoreFilter()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM005) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM001) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16f5d598","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckManagement/ShopperFilterModal.vue
// module id = 1656
// module chunks = 1